export default {
  'common.ReLogin': 'ReLogin',
  'common.ChangePassword': 'Change password',
  'common.Logout': 'Log out',
  'common.LoginStatusInvalid': 'Login status is invalid, please log in again!',
  'common.BackHome': 'Back home',
  'message.HTTP_403': 'Sorry, you are not authorized to access this page.',
  'message.HTTP_404': 'Sorry, the page you visited does not exist.',
};
